export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/admin": [3],
		"/admin/announcements": [4],
		"/admin/satisfactory-versions": [5],
		"/admin/tag-manager": [6],
		"/admin/unapproved-mods": [7],
		"/admin/unapproved-versions": [8],
		"/api-docs": [9],
		"/community": [10],
		"/content-policy": [11],
		"/guides": [14],
		"/guide/[guideId]": [12],
		"/guide/[guideId]/edit": [13],
		"/help": [15],
		"/mods": [22],
		"/mod/[modId]": [16],
		"/mod/[modId]/edit": [17],
		"/mod/[modId]/new-version": [18],
		"/mod/[modId]/version/[versionId]": [19],
		"/mod/[modId]/version/[versionId]/edit": [20],
		"/mod/[modId]/version/[versionId]/view": [21],
		"/new-guide": [23],
		"/new-mod": [24],
		"/privacy-policy": [25],
		"/settings": [26],
		"/sml-versions": [~27],
		"/tools": [28],
		"/tos": [29],
		"/user/[userId]": [30]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';